const exteriorFinishElements = document.querySelectorAll('[data-option="Exterior finish"] input[name="options\\[Exterior finish\\]"]');
const finsFinishOption = document.querySelector(".variant-selector-labels");

exteriorFinishElements.forEach((el) => {
    el.addEventListener("click", () => {
        if (el.value === "Plant fibre") {
            finsFinishOption.classList.remove("variant-selector-labels--hidden-options");
        } else {
            finsFinishOption.classList.add("variant-selector-labels--hidden-options");
        }
    });
});
